export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2b-6d3c96b430e6332e117f4bc3876b1ede.webp";